import { ITimesAction, ITimesState } from './times.types'
import { TimesConstants } from './times.constants'

export const initialTimesState: ITimesState = {
  onsetTime: '',
  onsetDateTimePNNV: null,
  receivedTime: '',
  dispatchNotifiedTime: '',
  standbyTime: '',
  dispatchedTime: '',
  acknowledgedTime: '',
  enRouteTime: '',
  enRouteDateTimePNNV: null,
  onsetDate: '',
  receivedDate: '',
  receivedDateTimePNNV: null,
  dispatchNotifiedDate: '',
  standbyDate: '',
  dispatchedDate: '',
  acknowledgedDate: '',
  enRouteDate: '',
  stagingTime: '',
  onSceneTime: '',
  atPatientTime: '',
  transferCareEMSTime: '',
  leaveReferringTime: '',
  arriveReceivingTime: '',
  transferCareDestinationTime: '',
  transferCareDestinationDateTimePNNV: null,
  availableTime: '',
  callCompletedTime: '',
  inQuartersTime: '',
  cancelledTime: '',
  firstResponderTime: '',
  stagingDate: '',
  onSceneDate: '',
  onSceneDateTimePNNV: null,
  atPatientDate: '',
  atPatientDateTimePNNV: null,
  transferCareEMSDate: '',
  transferCareEMSDateTimePNNV: null,
  leaveReferringDate: '',
  leaveReferringDateTimePNNV: null,
  arriveReceivingDate: '',
  arriveReceivingDateTimePNNV: null,
  transferCareDestinationDate: '',
  availableDate: '',
  callCompletedDate: '',
  inQuartersDate: '',
  cancelledDate: '',
  firstResponderDate: '',
  leavePatientDate: '',
  leavePatientTime: '',
  descentDate: '',
  descentTime: '',
  atLandingDate: '',
  atLandingTime: '',
  custom1DateTimeLabel: '',
  custom1Date: '',
  custom1Time: '',
  custom2DateTimeLabel: '',
  custom2Date: '',
  custom2Time: '',
  custom3DateTimeLabel: '',
  custom3Date: '',
  custom3Time: '',
  custom4DateTimeLabel: '',
  custom4Date: '',
  custom4Time: '',
  __hideOnset: false,
  __hideReceived: false,
  __disableReceived: false,
  __hideDispatchNotified: false,
  __disableDispatchNotified: false,
  __hideStandby: false,
  __disableStandby: false,
  __hideAcknowledged: false,
  __disableAcknowledged: false,
  __hideEnRoute: false,
  __disableEnRoute: false,
  __hideStaging: false,
  __disableStaging: false,
  __hideOnScene: false,
  __disableOnScene: false,
  __hideAtPatient: false,
  __disableAtPatientForDisposition: false,
  __hideTransferCareEMS: false,
  __disableTransferCareEMSForDisposition: false,
  __hideLeaveReferring: false,
  __disableLeaveReferring: false,
  __hideArriveReceiving: false,
  __disableArriveReceiving: false,
  __disableArriveReceivingForDisposition: false,
  __hideTransferCareDestination: false,
  __disableTransferCareDestinationForDisposition: false,
  __hideCallCompleted: false,
  __disableCallCompleted: false,
  __hideInQuarters: false,
  __hideCancelled: false,
  __hideCancelledForDisposition: false,
  __disableCancelled: false,
  __hideFirstResponder: false,
  __hideLeavePatient: false,
  __hideDescentForDisposition: false,
  __disableDescentForDisposition: false,
  __hideAtLandingForDisposition: false,
  __disableAtLandingForDisposition: false,
  __hideCustom1DateTime: false,
  __hideCustom2DateTime: false,
  __hideCustom3DateTime: false,
  __hideCustom4DateTime: false,
  __disableCustom1DateTime: false,
  __disableCustom2DateTime: false,
  __disableCustom3DateTime: false,
  __disableCustom4DateTime: false,
  __disableFirstResponderForDisposition: false,
  __hideTransferCareEMSForDisposition: false,
  __hideTransferCareDestinationForDisposition: false,
  __hideArriveReceivingForDisposition: false,
  __hideFirstResponderForDisposition: false,
  __hideAtPatientForDisposition: false,
  __disableLeavePatientForDisposition: false,
  __hideLeavePatientForDisposition: false,
}

export function timesReducer(state: ITimesState = initialTimesState, action: ITimesAction): ITimesState {
  switch (action.type) {
    case TimesConstants.NOT_IMPLEMENTED:
      alert('Not Implemented')
      return state
    case TimesConstants.SET_ONSET_TIME:
      return { ...state, onsetTime: action.time }
    case TimesConstants.SET_ONSET_DATE_TIME_PNNV:
      return { ...state, onsetDateTimePNNV: action.onsetDateTimePNNV }
    case TimesConstants.SET_RECEIVED_TIME:
      return { ...state, receivedTime: action.time }
    case TimesConstants.SET_DISPATCH_NOTIFIED_TIME:
      return { ...state, dispatchNotifiedTime: action.time }
    case TimesConstants.SET_STANDBY_TIME:
      return { ...state, standbyTime: action.time }
    case TimesConstants.SET_DISPATCHED_TIME:
      return { ...state, dispatchedTime: action.time }
    case TimesConstants.SET_ACKNOWLEDGED_TIME:
      return { ...state, acknowledgedTime: action.time }
    case TimesConstants.SET_EN_ROUTE_TIME:
      return { ...state, enRouteTime: action.time }
    case TimesConstants.SET_EN_ROUTE_DATE_TIME_PNNV:
      return { ...state, enRouteDateTimePNNV: action.enRouteDateTimePNNV }
    case TimesConstants.SET_STAGING_TIME:
      return { ...state, stagingTime: action.time }
    case TimesConstants.SET_ON_SCENE_TIME:
      return { ...state, onSceneTime: action.time }
    case TimesConstants.SET_AT_PATIENT_TIME:
      return { ...state, atPatientTime: action.time }
    case TimesConstants.SET_TRANSFER_CARE_EMS_TIME:
      return { ...state, transferCareEMSTime: action.time }
    case TimesConstants.SET_LEAVE_REFERRING_TIME:
      return { ...state, leaveReferringTime: action.time }
    case TimesConstants.SET_ARRIVE_RECEIVING_TIME:
      return { ...state, arriveReceivingTime: action.time }
    case TimesConstants.SET_TRANSFER_CARE_DESTINATION_TIME:
      return { ...state, transferCareDestinationTime: action.time }
    case TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE_TIME_PNNV:
      return { ...state, transferCareDestinationDateTimePNNV: action.transferCareDestinationDateTimePNNV }
    case TimesConstants.SET_AVAILABLE_TIME:
      return { ...state, availableTime: action.time }
    case TimesConstants.SET_CALL_COMPLETED_TIME:
      return { ...state, callCompletedTime: action.time }
    case TimesConstants.SET_IN_QUARTERS_TIME:
      return { ...state, inQuartersTime: action.time }
    case TimesConstants.SET_CANCELLED_TIME:
      return { ...state, cancelledTime: action.time }
    case TimesConstants.SET_FIRST_RESPONDER_TIME:
      return { ...state, firstResponderTime: action.time }
    case TimesConstants.SET_ONSET_DATE:
      return { ...state, onsetDate: action.date }
    case TimesConstants.SET_RECEIVED_DATE:
      return { ...state, receivedDate: action.date }
    case TimesConstants.SET_RECEIVED_DATE_TIME_PNNV:
      return { ...state, receivedDateTimePNNV: action.receivedDateTimePNNV }
    case TimesConstants.SET_DISPATCH_NOTIFIED_DATE:
      return { ...state, dispatchNotifiedDate: action.date }
    case TimesConstants.SET_STANDBY_DATE:
      return { ...state, standbyDate: action.date }
    case TimesConstants.SET_DISPATCHED_DATE:
      return { ...state, dispatchedDate: action.date }
    case TimesConstants.SET_ACKNOWLEDGED_DATE:
      return { ...state, acknowledgedDate: action.date }
    case TimesConstants.SET_EN_ROUTE_DATE:
      return { ...state, enRouteDate: action.date }
    case TimesConstants.ADD_ONSET_CURRENT_DATETIME:
      return { ...state, onsetTime: action.time, onsetDate: action.date }
    case TimesConstants.ADD_RECEIVED_CURRENT_DATETIME:
      return { ...state, receivedTime: action.time, receivedDate: action.date }
    case TimesConstants.ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME:
      return { ...state, dispatchNotifiedTime: action.time, dispatchNotifiedDate: action.date }
    case TimesConstants.ADD_STANDBY_CURRENT_DATETIME:
      return { ...state, standbyTime: action.time, standbyDate: action.date }
    case TimesConstants.ADD_DISPATCHED_CURRENT_DATETIME:
      return { ...state, dispatchedTime: action.time, dispatchedDate: action.date }
    case TimesConstants.ADD_ACKNOWLEDGED_CURRENT_DATETIME:
      return { ...state, acknowledgedTime: action.time, acknowledgedDate: action.date }
    case TimesConstants.ADD_EN_ROUTE_CURRENT_DATETIME:
      return { ...state, enRouteTime: action.time, enRouteDate: action.date }
    case TimesConstants.SET_STAGING_DATE:
      return { ...state, stagingDate: action.date }
    case TimesConstants.SET_ON_SCENE_DATE:
      return { ...state, onSceneDate: action.date }
    case TimesConstants.SET_ON_SCENE_DATE_TIME_PNNV:
      return { ...state, onSceneDateTimePNNV: action.onSceneDateTimePNNV }
    case TimesConstants.SET_AT_PATIENT_DATE:
      return { ...state, atPatientDate: action.date }
    case TimesConstants.SET_AT_PATIENT_DATE_TIME_PNNV:
      return { ...state, atPatientDateTimePNNV: action.atPatientDateTimePNNV }
    case TimesConstants.SET_TRANSFER_CARE_EMS_DATE:
      return { ...state, transferCareEMSDate: action.date }
    case TimesConstants.SET_TRANSFER_CARE_EMS_DATE_TIME_PNNV:
      return { ...state, transferCareEMSDateTimePNNV: action.transferCareEMSDateTimePNNV }
    case TimesConstants.SET_LEAVE_REFERRING_DATE:
      return { ...state, leaveReferringDate: action.date }
    case TimesConstants.SET_LEAVE_REFERRING_DATE_TIME_PNNV:
      return { ...state, leaveReferringDateTimePNNV: action.leaveReferringDateTimePNNV }
    case TimesConstants.SET_ARRIVE_RECEIVING_DATE:
      return { ...state, arriveReceivingDate: action.date }
    case TimesConstants.SET_ARRIVE_RECEIVING_DATE_TIME_PNNV:
      return { ...state, arriveReceivingDateTimePNNV: action.arriveReceivingDateTimePNNV }
    case TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE:
      return { ...state, transferCareDestinationDate: action.date }
    case TimesConstants.SET_AVAILABLE_DATE:
      return { ...state, availableDate: action.date }
    case TimesConstants.SET_CALL_COMPLETED_DATE:
      return { ...state, callCompletedDate: action.date }
    case TimesConstants.SET_IN_QUARTERS_DATE:
      return { ...state, inQuartersDate: action.date }
    case TimesConstants.SET_CANCELLED_DATE:
      return { ...state, cancelledDate: action.date }
    case TimesConstants.SET_FIRST_RESPONDER_DATE:
      return { ...state, firstResponderDate: action.date }
    case TimesConstants.ADD_STAGING_CURRENT_DATETIME:
      return { ...state, stagingTime: action.time, stagingDate: action.date }
    case TimesConstants.ADD_ON_SCENE_CURRENT_DATETIME:
      return { ...state, onSceneTime: action.time, onSceneDate: action.date }
    case TimesConstants.ADD_AT_PATIENT_CURRENT_DATETIME:
      return { ...state, atPatientTime: action.time, atPatientDate: action.date }
    case TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME:
      return { ...state, transferCareEMSTime: action.time, transferCareEMSDate: action.date }
    case TimesConstants.ADD_LEAVE_REFERRING_CURRENT_DATETIME:
      return { ...state, leaveReferringTime: action.time, leaveReferringDate: action.date }
    case TimesConstants.ADD_ARRIVE_RECEIVING_CURRENT_DATETIME:
      return { ...state, arriveReceivingTime: action.time, arriveReceivingDate: action.date }
    case TimesConstants.ADD_TRANSFER_CARE_DESTINATION_CURRENT_DATETIME:
      return { ...state, transferCareDestinationTime: action.time, transferCareDestinationDate: action.date }
    case TimesConstants.ADD_AVAILABLE_CURRENT_DATETIME:
      return { ...state, availableTime: action.time, availableDate: action.date }
    case TimesConstants.ADD_CALL_COMPLETED_CURRENT_DATETIME:
      return { ...state, callCompletedTime: action.time, callCompletedDate: action.date }
    case TimesConstants.ADD_IN_QUARTERS_CURRENT_DATETIME:
      return { ...state, inQuartersTime: action.time, inQuartersDate: action.date }
    case TimesConstants.ADD_CANCELLED_CURRENT_DATETIME:
      return { ...state, cancelledTime: action.time, cancelledDate: action.date }
    case TimesConstants.ADD_FIRST_RESPONDER_DATETIME:
      return { ...state, firstResponderTime: action.time, firstResponderDate: action.date }
    case TimesConstants.SET_LEAVE_PATIENT_TIME:
      return { ...state, leavePatientTime: action.time }
    case TimesConstants.SET_LEAVE_PATIENT_DATE:
      return { ...state, leavePatientDate: action.date }
    case TimesConstants.ADD_LEAVE_PATIENT_CURRENT_DATETIME:
      return { ...state, leavePatientTime: action.time, leavePatientDate: action.date }
    case TimesConstants.SET_DESCENT_TIME:
      return { ...state, descentTime: action.time }
    case TimesConstants.SET_DESCENT_DATE:
      return { ...state, descentDate: action.date }
    case TimesConstants.ADD_DESCENT_CURRENT_DATETIME:
      return { ...state, descentTime: action.time, descentDate: action.date }
    case TimesConstants.SET_AT_LANDING_TIME:
      return { ...state, atLandingTime: action.time }
    case TimesConstants.SET_AT_LANDING_DATE:
      return { ...state, atLandingDate: action.date }
    case TimesConstants.ADD_AT_LANDING_CURRENT_DATETIME:
      return { ...state, atLandingTime: action.time, atLandingDate: action.date }
    case TimesConstants.SET_CUSTOM_1_DATETIME:
      return { ...state, custom1Date: action.date, custom1Time: action.time }
    case TimesConstants.SET_CUSTOM_1_DATE:
      return { ...state, custom1Date: action.date }
    case TimesConstants.SET_CUSTOM_1_TIME:
      return { ...state, custom1Time: action.time }
    case TimesConstants.SET_CUSTOM_2_DATETIME:
      return { ...state, custom2Date: action.date, custom2Time: action.time }
    case TimesConstants.SET_CUSTOM_2_DATE:
      return { ...state, custom2Date: action.date }
    case TimesConstants.SET_CUSTOM_2_TIME:
      return { ...state, custom2Time: action.time }
    case TimesConstants.SET_CUSTOM_3_DATETIME:
      return { ...state, custom3Date: action.date, custom3Time: action.time }
    case TimesConstants.SET_CUSTOM_3_DATE:
      return { ...state, custom3Date: action.date }
    case TimesConstants.SET_CUSTOM_3_TIME:
      return { ...state, custom3Time: action.time }
    case TimesConstants.SET_CUSTOM_4_DATETIME:
      return { ...state, custom4Date: action.date, custom4Time: action.time }
    case TimesConstants.SET_CUSTOM_4_DATE:
      return { ...state, custom4Date: action.date }
    case TimesConstants.SET_CUSTOM_4_TIME:
      return { ...state, custom4Time: action.time }
    case TimesConstants.SET_TIMES:
      return { ...state, ...action.times }
    case TimesConstants.RESET_TIMES_STATE:
      return {
        onsetTime: '',
        onsetDateTimePNNV: null,
        receivedTime: '',
        receivedDateTimePNNV: null,
        dispatchNotifiedTime: '',
        standbyTime: '',
        dispatchedTime: '',
        acknowledgedTime: '',
        enRouteTime: '',
        enRouteDateTimePNNV: null,
        onsetDate: '',
        receivedDate: '',
        dispatchNotifiedDate: '',
        standbyDate: '',
        dispatchedDate: '',
        acknowledgedDate: '',
        enRouteDate: '',
        stagingTime: '',
        onSceneTime: '',
        onSceneDateTimePNNV: null,
        atPatientTime: '',
        atPatientDateTimePNNV: null,
        transferCareEMSTime: '',
        transferCareEMSDateTimePNNV: null,
        leaveReferringTime: '',
        leaveReferringDateTimePNNV: null,
        arriveReceivingTime: '',
        arriveReceivingDateTimePNNV: null,
        transferCareDestinationTime: '',
        transferCareDestinationDateTimePNNV: null,
        availableTime: '',
        callCompletedTime: '',
        inQuartersTime: '',
        cancelledTime: '',
        firstResponderTime: '',
        stagingDate: '',
        onSceneDate: '',
        atPatientDate: '',
        transferCareEMSDate: '',
        leaveReferringDate: '',
        arriveReceivingDate: '',
        transferCareDestinationDate: '',
        availableDate: '',
        callCompletedDate: '',
        inQuartersDate: '',
        cancelledDate: '',
        firstResponderDate: '',
        leavePatientDate: '',
        leavePatientTime: '',
        descentDate: '',
        descentTime: '',
        atLandingDate: '',
        atLandingTime: '',
        custom1DateTimeLabel: '',
        custom1Date: '',
        custom1Time: '',
        custom2DateTimeLabel: '',
        custom2Date: '',
        custom2Time: '',
        custom3DateTimeLabel: '',
        custom3Date: '',
        custom3Time: '',
        custom4DateTimeLabel: '',
        custom4Date: '',
        custom4Time: '',
        __hideOnset: false,
        __hideReceived: false,
        __disableReceived: false,
        __hideDispatchNotified: false,
        __disableDispatchNotified: false,
        __hideStandby: false,
        __disableStandby: false,
        __hideAcknowledged: false,
        __disableAcknowledged: false,
        __hideEnRoute: false,
        __disableEnRoute: false,
        __hideStaging: false,
        __disableStaging: false,
        __hideOnScene: false,
        __disableOnScene: false,
        __hideAtPatient: false,
        __disableAtPatientForDisposition: false,
        __hideTransferCareEMS: false,
        __disableTransferCareEMSForDisposition: false,
        __hideLeaveReferring: false,
        __disableLeaveReferring: false,
        __hideArriveReceiving: false,
        __disableArriveReceiving: false,
        __hideTransferCareDestination: false,
        __disableTransferCareDestinationForDisposition: false,
        __hideCallCompleted: false,
        __disableCallCompleted: false,
        __hideInQuarters: false,
        __hideCancelled: false,
        __disableCancelled: false,
        __hideFirstResponder: false,
        __hideLeavePatient: false,
        __hideDescentForDisposition: false,
        __disableDescentForDisposition: false,
        __hideAtLandingForDisposition: false,
        __disableAtLandingForDisposition: false,
        __hideCustom1DateTime: false,
        __hideCustom2DateTime: false,
        __hideCustom3DateTime: false,
        __hideCustom4DateTime: false,
        __disableCustom1DateTime: false,
        __disableCustom2DateTime: false,
        __disableCustom3DateTime: false,
        __disableCustom4DateTime: false,
        __disableFirstResponderForDisposition: false,
        __disableArriveReceivingForDisposition: false,
        __hideCancelledForDisposition: false,
        __hideTransferCareDestinationForDisposition: false,
        __hideTransferCareEMSForDisposition: false,
        __hideArriveReceivingForDisposition: false,
        __hideFirstResponderForDisposition: false,
        __hideAtPatientForDisposition: false,
        __disableLeavePatientForDisposition: false,
        __hideLeavePatientForDisposition: false,
      }
    default:
      return state
  }
}
